import { c as _c } from "react/compiler-runtime";
import React from "react";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import type { ApiWave } from "@/generated/models/ApiWave";
import { useWaveLeaderboardRendererSet } from "../leaderboardRendererRegistry";
interface WaveLeaderboardDropProps {
  readonly drop: ExtendedDrop;
  readonly wave: ApiWave;
  readonly onDropClick: (drop: ExtendedDrop) => void;
}
export const WaveLeaderboardDrop: React.FC<WaveLeaderboardDropProps> = t0 => {
  const $ = _c(5);
  const {
    drop,
    wave,
    onDropClick
  } = t0;
  const {
    LeaderboardDrop
  } = useWaveLeaderboardRendererSet(wave.id);
  let t1;
  if ($[0] !== LeaderboardDrop || $[1] !== drop || $[2] !== onDropClick || $[3] !== wave) {
    t1 = <LeaderboardDrop drop={drop} wave={wave} onDropClick={onDropClick} />;
    $[0] = LeaderboardDrop;
    $[1] = drop;
    $[2] = onDropClick;
    $[3] = wave;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
};